export default __webpack_public_path__ + "static/media/ollantaytambo-cholitas.4f79f187.jpg";